module.exports = __webpack_public_path__ + "media/icons/pierwszy-wlasciciel-e938b3b4.png";